export enum AuditModelTypeEnum {
  Unknown = 1,
  Alert = 2,
  Audit = 3,
  Benchmark = 4,
  BenchmarkFilter = 5,
  Deal = 6,
  FormAnswer = 7,
  FormGroup = 8,
  FormGroupInstance = 9,
  FormGroupInstanceDocument = 10,
  FormInstance = 11,
  FormInstanceContact = 12,
  FormResponse = 13,
  FormTemplateCategory = 14,
  FormTemplateGroup = 15,
  FormTemplateQuestion = 16,
  FormTemplateSection = 17,
  FormTemplate = 18,
  PrintJob = 19,
  QuestionEnumValue = 20,
  QuestionEnum = 21,
  QuestionGroup = 22,
  QuestionRangeGroup = 23,
  QuestionRange = 24,
  Question = 25,
  User = 26,
  FormTemplateSectionVariant = 27,
  QuestionEnumValueVariant = 28,
  QuestionRangeVariant = 29,
  QuestionVariant = 30,
  VariantDeliveryMethod = 31,
  VariantLanguage = 32,
  Workflow = 33,
  WorkflowStep = 34,
  FormInstanceMergeHistory = 35,
  FormResponseMergeHistory = 36,
  FormAnswerMergeHistory = 37,
  FormInstanceCFETMergeHistory = 38,
  FormInstanceCFETResponseMergeHistory = 39,
  Contact = 40,
  Company = 41,
  FormGroupCompany = 42,
  FormGroupPrimaryContact = 43,
  CompanyDeal = 44,
  ContactDeal = 45,
  ScheduledEmail = 46,
  ReportAccess = 47,
  UserDevice = 48,
  UserRole = 49,
  UserImpersonation = 50,
  PasswordResetToken = 51,
  QuestionVariantGroup = 52,
}

export enum AuditModelFilterTypeEnum {
  Unknown = 1,
  Alert = 2,
  Audit = 3,
  Benchmark = 4,
  BenchmarkFilter = 5,
  Contact = 38,
  Company = 39,
  Deal = 6,
  PasswordResetToken = 50,
  PrintJob = 19,
  FormAnswer = 7,
  FormAnswerMergeHistory = 37,
  FormInstance = 11,
  FormInstanceContact = 12,
  FormInstanceMergeHistory = 35,
  FormResponse = 13,
  FormResponseMergeHistory = 36,
  FormTemplate = 18,
  ReportAccess = 44,
  FormGroupInstance = 9,
  FormGroupInstanceDocument = 10,
  FormGroup = 8,
  User = 26,
  UserImpersonation = 49,
  UserRole = 40,
  Question = 25,
}

export const AuditModelTypeDisplayNames: { [key: string]: string } = {
  Unknown: "Unknown",
  Alert: "Alert",
  Audit: "Audit",
  Benchmark: "Benchmark",
  BenchmarkFilter: "Benchmark Filter",
  FormTemplateCategory: "Form Template Category",
  FormTemplateGroup: "Form Template Group",
  FormTemplateQuestion: "Form Template Question",
  FormTemplateSection: "Form Template Section",
  FormTemplateSectionVariant: "Form Template Section Variant",
  Company: "HubSpot Company",
  Contact: "HubSpot Contact",
  Deal: "Hubspot Deal",
  PrintJob: "Print Job",
  FormInstance: "PSID",
  FormAnswer: "PSID Answer",
  FormAnswerMergeHistory: "PSID Answer Merge History",
  FormInstanceContact: "PSID Contact",
  FormInstanceMergeHistory: "PSID Merge History",
  FormResponse: "PSID Response",
  FormResponseMergeHistory: "PSID Response Merge History",
  Question: "Question",
  QuestionEnum: "Question List Group",
  QuestionEnumValue: "Question List Group Value",
  QuestionEnumValueVariant: "Question List Group Value Variant",
  QuestionGroup: "Question Group",
  QuestionRange: "Question Range",
  QuestionRangeGroup: "Question Range Group",
  QuestionRangeVariant: "Question Range Variant",
  FormTemplate: "Questionnaire Template",
  QuestionVariant: "Question Variant",
  FormGroupInstance: "Survey",
  FormGroupInstanceDocument: "Survey Document",
  FormGroup: "Survey Product",
  User: "User",
  VariantDeliveryMethod: "Variant Delivery Method",
  VariantLanguage: "Variant Language",
  Workflow: "Workflow",
  WorkflowStep: "Workflow Step",
  UserRole: "User Role",
  createdAt: "Created On",
  updatedAt: "Last Updated On",
  formAnswerId: "PSID Answer ID",
  formAnswer_deletedAt: "PSID Answer Deleted At",
  formInstanceMergeHistoryId: "PSID Merge Merge History ID",
  formTemplateQuestionId: "Form Template Question ID",
  id: "ID",
  externalDealId: "HubSpot Deal ID",
  formInstanceId: "PSID ID",
  isClosed: "Is Closed",
  isOnline: "Is Online",
  resolvedById: "Resolved By ID",
  resolvedDate: "Resolved Date",
  submissionUUID: "Submission UUID",
  type: "Type",
  uuid: "UUID",
  deletedAt: "Deleted On",
  contactExternalId: "HubSpot Contact ID",
  formGroupInstanceDocumentId: "PSID Document ID",
  formGroupInstanceId: "PSID Instance ID",
  ReportAccess: "Report Access",
  UserImpersonation: "User Impersonation",
  PasswordResetToken: "Password Reset Token",
  // CFEP NP-343 AC5: the approval override action and its recorded details.
  ApprovalOverride: "Approval Override",
  overrideJustification: "Override Justification",
  overrideRole: "Role",
  reviewVersion: "Review Version",
  reviewCycle: "Review Cycle",
  reviewRoundId: "Review Round ID",
  // CFEP NP-298: discussion actions (30-33) and their recorded details.
  DiscussionCommentEdited: "Discussion Comment Edited",
  DiscussionCommentDeleted: "Discussion Comment Deleted",
  DiscussionResolved: "Discussion Resolved",
  DiscussionReopened: "Discussion Reopened",
  surveyProductId: "Survey Product ID",
  discussionId: "Discussion ID",
  commentId: "Comment ID",
  authorUserId: "Comment Author User ID",
  anchorType: "Commented Content",
  anchorId: "Commented Content ID",
  selectedText: "Selected Text",
  previousText: "Previous Text",
  deletedText: "Deleted Text",
};

export const enum AuditGroupingEum {
  security = 1,
  data = 2,
  communication = 3,
}

export const enum AuditActionTypeEnum {
  Add = 1,
  Edit = 2,
  Delete = 3,
  Link = 4,
  Unlink = 5,
  WorkflowStart = 6,
  WorkflowProgress = 7,
  WorkflowStop = 8,
  Login = 9,
  ForgotPassword = 10,
  PasswordReset = 11,
  LoginFailure = 12,
  InvalidUser = 13,
  EmailSent = 14,
  ImpersonationStarted = 19,
  ImpersonationEnded = 20,
  ImpersonationExpired = 21,
  Timeout = 22,
  InvalidPermissions = 23,
  ExpiredPasswordToken = 24,
  UsedPasswordToken = 25,
  ExpiredReportLink = 26,
  EmailReminderOptOut = 27,
  EmailReminderStop = 28,
}

export enum AuditModelFilterActionTypeEnum {
  Add = 1,
  Edit = 2,
  Delete = 3,
  EmailSent = 14,
  EmailReminderOptOut = 27,
  EmailReminderStop = 28,
  ApprovalOverride = 29,
  DiscussionCommentEdited = 30,
  DiscussionCommentDeleted = 31,
  DiscussionResolved = 32,
  DiscussionReopened = 33,
  ExpiredPasswordToken = 24,
  ExpiredReportLink = 26,
  ForgotPassword = 10,
  InvalidPermissions = 23,
  InvalidUser = 13,
  ImpersonationStarted = 19,
  ImpersonationEnded = 20,
  ImpersonationExpired = 21,
  Login = 9,
  LoginFailure = 12,
  Link = 4,
  PasswordReset = 11,
  Timeout = 22,
  Unlink = 5,
  UsedPasswordToken = 25,
  WorkflowStart = 6,
  WorkflowProgress = 7,
  WorkflowStop = 8,
}

export const enum AuditFlattenedValueKeysEnum {
  IsApproved = "isApproved",
  IsArhived = "isArchived",
  IsInChangesRequired = "isInChangesRequired",
  IsClosed = "isClosed",
  IsComplete = "isComplete",
  IsDeleted = "isDeleted",
  IsDraft = "isDraft",
  IsInReview = "isInReview",
  IsOnline = "isOnline",
  IsPracticeOnly = "isPracticeOnly",
  IsPublished = "isPublished",
  IsReportSent = "isReportSent",
  IsPreviewData = "isPreviewData",
  IsMSF = "isMSF",
  IsAvailableOffline = "isAvailableOffline",
  BrandingType = "brandingType",
  ReadyToSend = "readyToSend",
  HaveMinimumResponsesNotBeenReceived = "haveMinimumResponsesNotBeenReceived",
  HasSentMinThresholdReachedEmail = "hasSentMinThresholdReachedEmail",
  HasSentPerctThresholdReachedEmail = "hasSentPerctThresholdReachedEmail",
  WorkflowStepId = "workflowStepId",
  WorkflowStepCurrent = "workflowStepId.current",
  WorkflowStepPrevious = "workflowStepId.previous",
  EmailTemplateId = "emailPayloadData.templateId",
  UserType = "userType",
  UserRole = "roleId",
  AlertType = "type",
}
